// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"12643bf61e8f267c4caf","777":"140892f51e143b903ae8"}[chunkId] + ".bundle.js";
};